import { render, staticRenderFns } from "./TheMyFavoritesProductOptionsSaveToCollection.vue?vue&type=template&id=35044a37&scoped=true"
import script from "./TheMyFavoritesProductOptionsSaveToCollection.vue?vue&type=script&lang=js"
export * from "./TheMyFavoritesProductOptionsSaveToCollection.vue?vue&type=script&lang=js"
import style0 from "./TheMyFavoritesProductOptionsSaveToCollection.vue?vue&type=style&index=0&id=35044a37&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35044a37",
  null
  
)

export default component.exports